import React, { useEffect } from "react";
import img1 from "../images/logo/ARS_logo.png";
import img2 from "../images/logo/Logo_agence_de_l'eau_Seine-Normandie.png";
import img3 from "../images/logo/afb_logo.png";
import img4 from "../images/logo/2560px-Région_Île-de-France_(logo_2005).png";
import img5 from "../images/logo/1280px-Logo_Yvelines_2015.png";
import img6 from "../images/logo/1280px-Logo_Hauts_Seine_2014.png";
import img7 from "../images/logo/Remove-bg.ai_1716799868890.png";
import img8 from "../images/logo/Remove-bg.ai_1716799657993.png";
import img9 from "../images/logo/Remove-bg.ai_1716799902707.png";

const imagesLogo = [
  { id: 1, img: img1 },
  { id: 2, img: img2 },
  { id: 3, img: img3 },
  { id: 4, img: img4 },
  { id: 5, img: img5 },
  { id: 6, img: img6 },
  { id: 7, img: img7 },
  { id: 8, img: img8 },
  { id: 8, img: img9 },
];
const ServiceDetails = () => {
  useEffect(() => {
    if (window.location.hash === "#partenaire") {
      const partenaireSection = document.getElementById("partenaire");
      if (partenaireSection) {
        partenaireSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);
  return (
    <div className="mb-20">
      <div className="container mt-20 md:mb-10">
        <h1 className="text-2xl font-bold text-center text-black">
          AQUAVESC, le service public de l'eau
        </h1>
        <div className="w-full mt-20 rounded-3xl">
          <iframe
            title="service"
            src="https://www.youtube.com/embed/yp9F5W9jVHA"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            className="w-full h-[500px] rounded-3xl"
          ></iframe>
        </div>
        <div className="mt-10">
          <h1 className="text-2xl font-bold text-black">
            AQUAVESC, le service public de l'eau
          </h1>
          <p className="mt-2 text-justify">
            {" "}
            AQUAVESC est un établissement territorial <br />
            Il assure :
            <ul className="ml-20 list-disc">
              <li>La production </li>
              <li>Le traitement </li>
              <li>
                La distribution de 25 millions de m³ d’eau potable chaque année.{" "}
              </li>
            </ul>
            <p className="mt-2 text-justify">
              Le syndicat réalise en maitrise d’ouvrage directe les travaux de
              grande ampleur nécessaire à la fiabilisation et l’amélioration du
              service public dont il a la charge.
            </p>
            <p className="mt-2 text-justify">
              AQUAVESC est administré par un Comité composé des délégués élus
              par les communes et les intercommunalités adhérentes/. Le bureau
              prépare les décisions stratégiques et d’orientation qui sont
              soumises au côté du comité.
            </p>
            <p className="mt-2 text-justify">
              Le syndicat a délégué à un exploitant certain nombre d’opérations
              : exploitation des ouvrages de production, de distribution, de
              stockage de l’eau potable, renouvellement de canalisations,
              surveillance du réseau.
            </p>
            <p className="mt-2 text-justify">
              En tant que responsable du service public de l’eau potable,
              AQUAVESC veille au bon fonctionnement du service assuré par les
              délégataires sélectionnés avec une organisation dédiée : comité de
              gouvernance et de contrôle financier, commission d’appel d’offres,
              commissions thématiques : travaux, finances …
            </p>
            <p className="mt-4 font-bold">L’innovation au service de l’eau</p>
            <p className="mt-2 text-justify">
              Pour optimiser la gestion du patrimoine, de réduire les
              interruptions de service et de préserver la ressource. AQUAVESC a
              connecté son réseau en l’équipant de plus de 750 capteurs et en se
              dotant d’outils innovants servant à :
              <ul className="ml-20 list-disc">
                <li>
                  Lutter contre les variations de pression dans les
                  canalisations afin d’en prévenir les ruptures{" "}
                  <span className="font-bold">(CalmNetwork)</span>
                </li>
                <li>
                  Anticiper les risques de casses en un point précis du réseau.
                  Ceci permet à AQUAVESC de réaliser une programmation des
                  travaux plus efficace, d’anticiper le renouvellement des
                  canalisations, d’éviter les casses et ainsi les désagréments
                  pour les usagers <span className="font-bold">(Netscan).</span>{" "}
                </li>
              </ul>
            </p>
            <p className="mt-2 text-justify">
              Engagé dans une démarche éco-responsable, AQUAVESC favorise
              l'économie circulaire en distribuant les boues issues de la
              décarbonatation aux agriculteurs pour les épandre dans leurs
              champs. En accord avec notre engagement pour l'économie
              circulaire, AQUAVESC met en œuvre sur le site de son usine :
              <ul className="mt-4 ml-20 list-disc">
                <li>
                  <span className="font-bold">Le Zéro-Phyto :</span> pour
                  préserver les nappes phréatiques des pesticides et autres
                  produits phytosanitaires.
                </li>
                <li>
                  {" "}
                  <span className="font-bold">L'éco-pâturage</span>
                </li>
                <li>
                  Le{" "}
                  <span className="font-bold">traitement des eaux usées</span>{" "}
                  (industrielles, pluviales incendie) via une lagune paysagère à
                  l’usine de Louveciennes.
                </li>
              </ul>
            </p>
            <p className="mt-2 text-justify">
              <span className="font-bold">AQUAVESC</span> se positionne comme un
              acteur incontournable dans la gestion de l'eau potable sur son
              territoire d'intervention. Guidé par une vision constamment
              tournée vers l'innovation, le syndicat trace une voie novatrice en
              investissant dans des projets de développement durable et
              d'économie circulaire pour répondre aux défis actuels de la
              gestion d'une ressource qui se raréfie.
            </p>
          </p>
        </div>
      </div>

      <div className="bg-bg_aquavesc" id="partenaire">
        <h1 className="p-20 text-3xl font-bold text-center text-black">
          LES PARTENAIRES D'AQUAVESC
        </h1>
        <div className="ml-40 mr-40">
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5 lg:grid-cols-3 justify-items-center">
            {imagesLogo.map(({ id, img }) => (
              <div key={id} className="mt-20 mb-20">
                <img src={img} alt={`Logo ${id}`} className="w-40 " />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetails;
